import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  message,
  Row,
  Col,
  Tooltip,
  Spin,
  DatePicker,
  Space,
  InputNumber,
  Divider,
} from 'antd';
import {
  renderCardStatusColor,
  renderMyJoinStatus,
  MYJOINSTATUS,
  ACTIVITY_TYPE,
  JOINSTATUS,
  renderActivityType,
} from '@/constants/zongcu';
import apis from '../../apis';
import { MenuOutlined, AppstoreOutlined } from '@ant-design/icons';
import { Link, withRouter } from 'react-router-dom';
import './index.less';
import { formateTimeStamp } from '@/common/utils';
import ZongCuList from '@/components/zongcu-list';
import classnames from 'classnames';
import FormBoxes from '@/components/filter-new-boxes';
import Card from '@/components/card';
import Copy from '@/components/copy';
import useGetFirstData from '@/hooks/useGetZCFirstData';
import useDidUpdate from '@/hooks/useDidUpdate';
import { connect } from 'react-redux';
import { setDailyJoin } from '@/store/zongzu-form';
import Empty from '@/components/core-empty';

const { Option } = Select;

const ZongcuActivity = (props) => {
  // 存放搜索框内容
  const initalState = {
    currentPage: 1,
    pageSize: 10,
  };

  const [conditions, setConditions] = useState(initalState);
  const [listConditions, setListConditions] = useState(initalState);
  const [applyValidStatus, setApplyValidStatus] = useState(null);
  // 存放主接口数据
  const initialContent = {
    list: [],
    totalPage: '',
    totalCount: '',
    loading: '',
  };

  const [cardCurrPage, setCardCurrPage] = useState(1);
  const [content, setContent] = useState(initialContent);
  const [listContent, setListContent] = useState(initialContent);

  const [searchForm] = Form.useForm();
  const timeout = useRef(null);
  const [more, setMore] = useState(false);
  const [type, setType] = useState('list');

  const getInitialContent = useGetFirstData(apis.zongcuParticipatedList, props.zongcuFormInfo);

  useEffect(() => {
    setContent(getInitialContent);
    setListContent(getInitialContent);
  }, [getInitialContent]);

  useEffect(() => {
    if (JSON.stringify(props.zongcuFormInfo) === '{}') return;
    searchForm.setFieldsValue(props.zongcuFormInfo);
    onFinish(props.zongcuFormInfo);
    // eslint-disable-next-line
  }, [props.zongcuFormInfo]);

  // 请求主接口数据
  /* eslint-disable */
  useDidUpdate(() => {
    if (!more) {
      setContent((data) => ({ ...data, loading: true }));
    }

    const allConditions = Object.assign({}, conditions);

    apis
      .zongcuParticipatedList(allConditions)
      .then((res) => {
        const {
          ret,
          data: { list = [], totalPage, totalCount },
        } = res;
        if (ret === '0') {
          if (more) {
            setContent({
              list: content.list.concat(list),
              loading: false,
              totalPage,
              totalCount,
            });
          } else {
            setContent({
              list: list,
              loading: false,
              totalPage,
              totalCount,
            });
          }
        } else {
          message.error(res.msg);
          setContent({
            loading: false,
            ...content,
          });
        }
      })
      .catch((ex) => {
        message.error(ex);
        setContent({
          loading: false,
          ...content,
        });
      });
  }, [conditions]);
  /* eslint-enable */

  // 请求主接口数据
  /* eslint-disable */
  useDidUpdate(() => {
    const allConditions = Object.assign({}, listConditions);

    apis
      .zongcuParticipatedList(allConditions)
      .then((res) => {
        const {
          ret,
          data: { list = [], totalPage, totalCount },
        } = res;
        if (ret === '0') {
          if (more) {
            setListContent({
              list,
              loading: false,
              totalPage,
              totalCount,
            });
          } else {
            setListContent({
              list,
              loading: false,
              totalPage,
              totalCount,
            });
          }
        } else {
          message.error(res.msg);
          setListContent({
            loading: false,
            ...listContent,
          });
        }
      })
      .catch((ex) => {
        message.error(ex);
        setListContent({
          loading: false,
          ...listContent,
        });
      });
  }, [listConditions]);
  /* eslint-enable */

  const onFinish = (values = {}) => {
    setMore(false);
    props.setZongcuInfo(values);
    const { onlineFlag = '', macActId = '', zongcuName = null, activityTypes = '', beginAndEndTime = [] } = values;
    const startQueryTime = beginAndEndTime && beginAndEndTime.length > 0 ? beginAndEndTime[0]?.valueOf() : '';
    const endQueryTime = beginAndEndTime && beginAndEndTime.length > 0 ? beginAndEndTime[1]?.valueOf() : '';
    if (type == 'card') {
      setConditions({
        ...conditions,
        ...initalState,
        onlineFlag,
        name: zongcuName,
        macActId,
        activityTypes,
        startQueryTime,
        endQueryTime,
      });
    } else {
      setListConditions({
        ...listConditions,
        ...initalState,
        onlineFlag,
        name: zongcuName,
        macActId,
        activityTypes,
        startQueryTime,
        endQueryTime,
      });
    }
  };

  function toLoadingMore() {
    setMore(true);
    setConditions({ ...conditions, currentPage: cardCurrPage + 1 });
    setCardCurrPage(cardCurrPage + 1);
  }

  function reset() {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {}, 1000);
  }

  function toTB(id) {
    props.history.push(
      `/activity-manage/myCreate/zongcuActivity/myJoin/detail/activityEnroll/detail?activity_id=${id}`
    );
  }

  // 渲染卡片本身
  function renderCardItem(item) {
    return (
      <Card
        key={item.id}
        className="zongcu-card-item"
        shadow
        container={{
          padding: { vertical: 'normal', horizontal: 'normal' },
          margin: false,
        }}
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.02)', border: '1px solid #e9e9e9' }}
        onClick={() => toTB(item.id, item.activityStatus)}
      >
        <div className="content">
          <div className="title" onClick={(e) => e.preventDefault()}>
            <Tooltip title={item.name}>
              <div className="title-act-name">{item.name}</div>
            </Tooltip>
            <Divider type="vertical" />
            <div className={renderCardStatusColor(item.applyStatus)}>{renderMyJoinStatus(item.applyStatus)}</div>
          </div>
          <div className="status-wrap">
            {!!item.crossProduct && <div className="activity-type">跨品类营销</div>}
            <Tooltip title={renderActivityType(item.activityType).name}>
              <div className="activity-type">{renderActivityType(item.activityType).text}</div>
            </Tooltip>
          </div>
          <div className="ID-title">
            活动编号：
            <span className="ID">
              <Copy text={item.macActId} size="small" />
            </span>
          </div>
          <div className="time-title">
            报名时间：<span className="startTime">{formateTimeStamp(item.applyBeginTime, true)}</span>
          </div>
          <div className="endTime">{formateTimeStamp(item.applyEndTime, true)}</div>
        </div>
      </Card>
    );
  }

  function switchStatusType(applyValidStatus) {
    setMore(false);
    setCardCurrPage(1);
    setApplyValidStatus(applyValidStatus);
    type == 'card'
      ? setConditions({ ...conditions, applyStatus: applyValidStatus, currentPage: 1 })
      : setListConditions({ ...listConditions, applyStatus: applyValidStatus, currentPage: 1 });
  }

  const formItemArr = [
    <Form.Item name="macActId" label="活动编号" key={1} span={6} colon={false}>
      <InputNumber placeholder="请输入活动编号" controls={false} />
    </Form.Item>,
    <Form.Item name="zongcuName" label="活动名称" key={2} span={6} colon={false}>
      <Input placeholder="请输入活动名称" />
    </Form.Item>,
    <Form.Item name="beginAndEndTime" label="活动时间" key={3} span={6} colon={false}>
      <DatePicker.RangePicker showTime format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }} />
    </Form.Item>,
    <Form.Item name="onlineFlag" label="状态" key={4} span={6} colon={false}>
      <Select placeholder="不限" allowClear className="all-about-me-signed-activity-select">
        {MYJOINSTATUS.map((item) => (
          <Option key={item.val} value={item.val}>
            {item.title}
          </Option>
        ))}
      </Select>
    </Form.Item>,
    <Form.Item name="activityTypes" label="综促类型" key={5} span={6} colon={false}>
      <Select placeholder="不限" allowClear className="all-about-me-signed-activity-select">
        {ACTIVITY_TYPE.map((item) => (
          <Option key={item.value} value={item.value}>
            {item.name}
          </Option>
        ))}
      </Select>
    </Form.Item>,
  ];

  const btnInitialForm = (
    <>
      <Form.Item>
        <Button type="primary" htmlType="submit" shape="round">
          查询
        </Button>
      </Form.Item>
      <Form.Item>
        <Button
          onClick={() => {
            searchForm.resetFields();
            onFinish();
          }}
          shape="round"
        >
          重置
        </Button>
      </Form.Item>
    </>
  );

  return (
    <div className="my-join-zongcu-wrap">
      <div className="zongcu-search">
        <div style={{ display: 'flex', marginBottom: '16px' }}>
          <div className="applied-status-key-fa common-filter-key">报名状态：</div>
          <div className="applied-status-val-fa">
            {Object.values(JOINSTATUS) &&
              Object.values(JOINSTATUS)?.map((item) => {
                return (
                  <span
                    key={item.value}
                    className={classnames(
                      item.value === applyValidStatus ? 'common-filter-val choosed' : 'common-filter-val',
                      'applied-status-item'
                    )}
                    onClick={() => switchStatusType(item.value)}
                  >
                    {item.name}
                  </span>
                );
              })}
          </div>
        </div>
        <Form form={searchForm} onFinish={onFinish}>
          <FormBoxes formItemArr={formItemArr} form={searchForm} btnForm={btnInitialForm} />
        </Form>
      </div>
      <div className="zongcu-applied-status-fa">
        <div className="change-style">
          <Space size={20}>
            <MenuOutlined
              className={type == 'list' ? 'icon selected' : 'icon'}
              onClick={() => {
                setType('list');
              }}
            />
            <AppstoreOutlined
              className={type == 'card' ? 'icon selected' : 'icon'}
              onClick={() => {
                setType('card');
              }}
            />
          </Space>
        </div>
      </div>

      {type == 'list' ? (
        <div className="zongcu-list-wrap">
          <ZongCuList
            data={listContent}
            conditions={listConditions}
            setConditions={setListConditions}
            toTB={toTB}
            flag="join"
          />
        </div>
      ) : (
        <>
          {!content.loading ? (
            content.list.length > 0 ? (
              <div className="zongcu-card-wrap">
                {content.list.map((item) => {
                  return renderCardItem(item);
                })}
                {conditions.currentPage < content.totalPage ? (
                  <div className="zongcu-loading-more" onClick={toLoadingMore}>
                    更多 &gt;
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="zongcu-empty">
                <Empty style={{ color: 'rgba(0,0,0,0.82)' }} />
              </div>
            )
          ) : (
            <div className="zongcu-spin">
              <Spin />
            </div>
          )}
        </>
      )}
    </div>
  );
};

const _ZongcuActivity = connect(
  (state) => {
    return {
      zongcuFormInfo: state.zongcuFormInfo?.dailyJoin,
    };
  },
  (dispatch) => {
    return {
      setZongcuInfo(props) {
        dispatch(setDailyJoin(props));
      },
    };
  }
)(ZongcuActivity);

export default withRouter(_ZongcuActivity);
